import { themeImage } from "@/lib/media";
import { footerClass, headClass } from "./authFormClasses";

/**
 * What the sign-in, register and forgot password modals show instead of their
 * forms while the DAS platform API isn't set up in the dashboard.
 */
export default function SigninUnavailable() {
  return (
    <div>
      <div className={headClass}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={themeImage("logo-dark.png")} alt="DAS Academies" />
      </div>

      <div className="mx-auto mb-7.5 max-w-[500px] text-center font-das text-[#333]">
        <h3 className="mb-2.5 text-[20px]">Sign-in isn&apos;t available yet</h3>

        <p className="text-[16px] font-light">
          Online accounts for DAS Academies are being set up. Please check back
          soon.
        </p>
      </div>

      <div className={footerClass}>
        <p>
          Need help in the meantime? <a href="/contact">Contact us</a>
        </p>
      </div>
    </div>
  );
}
